module.exports = __webpack_public_path__ + "img/2179e12.svg";